import { $api } from "@/shared/api";

// Тепловая карта готового разбора: матч завершён, данные не меняются — из кэша навсегда.
export const useAnalysisMap = (analysisId: number) =>
  $api.useQuery(
    "get",
    "/api/analyses/{analysis_id}/map",
    { params: { path: { analysis_id: analysisId } } },
    { staleTime: Infinity, gcTime: Infinity, retry: false },
  );
